import { apiClient } from "helpers/api_helper"

export const GetAllOldGoldPurchaseData = async (data: object) => {
    try {
        const response = await apiClient.get(`/api/v1/PurchaseOrder/GetOldGoldPurchaseList`, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const GetOldGoldPurchaseOrderItemList = async (id: string) => {
    try {
        const response = await apiClient.get(`/api/v1/PurchaseOrder/GetOldGoldPurchaseOrderItemList?purchaseOrderId=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const GetOldGoldPurchaseOrderVoucher = async (id: string) => {
    try {
        const response = await apiClient.get(`/api/v1/PurchaseOrder/GeneratePurchaseOrderVoucher?purchaseOrderId=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};